import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { GET_SESSION_DETAILS } from './ground-truth-updates.reducer';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid2 } from '@mui/material';
import PlayAnalysisCard from './play-analysis-card/play-analysis-card';
// import BusyLoaderSimple from '../../components/loading-spinner/busy-loader-simple';
import { isAdminUserAccount } from '../../helpers/utils';

const SessionDetails = () => {
  const params = useParams();
  const sessionId = params.id || null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    sessionDetails,
    actionInProgress,
    playClips = []
  } = useSelector((state) => state.groundTruthUpdates);
  const { sessionDetails: userSessionDetails } = useSelector((state) => state.auth);
  const adminUser = isAdminUserAccount(userSessionDetails);

  useEffect(() => {
    if (sessionId) {
      dispatch({
        type: GET_SESSION_DETAILS,
        payload: {
          sessionId,
        },
      });
    }
  }, [sessionId]);

  return (
    <Stack direction="column" spacing={2} mb="2rem" sx={{ flexGrow: 1 }}>
      <Box
        sx={{
          textAlign: 'center',
          marginBottom: '2rem',
        }}
      >
        <h1>{`Ground Truth Updates: ${sessionId}`}</h1>
      </Box>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="flex-end"
      >
        <Box width="100%" textAlign="right">
          <Button onClick={() => navigate('/ground-truth-updates')} variant="contained" color="primary">
            {'Back to Session List'}
          </Button>
        </Box>
      </Stack>

      <Box sx={{ flexGrow: 1 }}>
        <Grid2 container size="xl">
          <Grid2 item xs={12} sx={{ height: '3rem', marginY: '0.5rem' }}>
            {
              actionInProgress
                ? (
                  <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Alert severity="info">{
                      Object.keys(sessionDetails).length === 0 ? 'Fetching session details...' : null
                    }</Alert>
                  </Stack>
                  )
                : null
            }
          </Grid2>
          <Box width={'100%'}>
            <Box sx={{ flexGrow: 1 }}>
              {!sessionDetails || (Array.isArray(sessionDetails) && sessionDetails.length === 0) ? (
                <Typography sx={{ m: 2, flex: 1 }} variant="h4" component="div">
                  No play clips available for this session.
                </Typography>
              ) : (
                <Grid2 container spacing={2}>
                  <PlayAnalysisCard
                    sessionId={sessionId}
                    sessionDetails={sessionDetails}
                    playClips={playClips}
                    adminUser={adminUser}
                  />
                </Grid2>
              )}
            </Box>
          </Box>
        </Grid2>
      </Box>
    </Stack>
  );
};

export default React.memo(SessionDetails);
